import React, { useContext, useEffect, useState } from "react";
import { FloatButton, Popover, Button, Dropdown, Tour, TourProps, TourStepProps } from "antd";
import { QuestionCircleTwoTone, CloseCircleOutlined } from "@ant-design/icons";
import { OpcoesDoUsuarioContext } from "../Contexts/OpcoesDoUsuarioContext";

export interface ITutorialPassos extends TourProps {
    acao?: () => void
}

export interface ITutorial {
    titulo: String,
    tutorial?: ITutorialPassos
}

const AdicionarAjuda: React.FC<{
    tutoriais: ITutorial[],
}> = (props) => {

    const opcoesDoUsuario = useContext(OpcoesDoUsuarioContext);

    const [openPopover, setOpenPopover] = useState(opcoesDoUsuario?.opcoesDoUsuario?.ocultarPopOverDeAjuda ? false : true);
    const [selectedTour, setSelectedTour] = useState<TourProps["steps"]>();
    const [openTour, setOpenTour] = useState(false);

    useEffect(() => {
        if(openPopover == false){
            opcoesDoUsuario?.setOpcoesDoUsuario((prev) => ({...prev, ocultarPopOverDeAjuda: true}));
            localStorage.setItem("_hide_popup", new Date().getTime().toString())
        }
    }, [openPopover, setOpenPopover])

    const hideTour = () => {
        setOpenTour(false);
    };

    const hidePopover = () => {
        setOpenPopover(false)
    }

    const handleSelectTour = (values: any) => {
        const selectedTour = props.tutoriais[values.key - 1].tutorial

        if (selectedTour?.acao) {
            selectedTour.acao()
        }

        setSelectedTour(selectedTour?.steps);
        setOpenTour(true);
    }

    /* Componente tour adicionado separadamente devido a bug na alternância de tutoriais.
       Aparentemente o componente não está resetando os passos ao trocar de tutorial, fazendo
       com que ao trocar de passo, caso o passo onde foi finalizado esteja fora do alcance
       do tutorial alternado, o mesmo não será exibido. */
    
    const Guide = (): JSX.Element => {
        return (
            <Tour open={openTour} onClose={hideTour} steps={selectedTour} />
        );
    }

    return ( 
        <>
            <Dropdown 
                menu={{
                    items: props.tutoriais.map((tutorial, index) => ({
                        label: tutorial.titulo,
                        key: index + 1,
                        onClick: handleSelectTour
                    }))
                }}
                trigger={[ "click" ]} 
                placement="top"
            >
                <Popover 
                    content={"Precisa de ajuda? Consulte os tutoriais aqui."} 
                    placement={"left"}
                    title={
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            Atenção!
                            <Button type="link" style={{ padding: 0 }} onClick={hidePopover}>
                                <CloseCircleOutlined style={{ color: "crimson", fontSize: "16px" }} />
                            </Button>
                        </div>}
                    open={openPopover} 
                >
                    <FloatButton className="btnAjuda" icon={<QuestionCircleTwoTone />} type="primary" onClick={hidePopover} />
                </Popover>
            </Dropdown>

            <Guide />
            {/* <Tour open={openTour} onClose={hideOpenTour} steps={selectedTour} current={0}/> */}
        </>
     );
}

export const MensagensPadrao = {
    filtros: {
        apresentacao: {
            title: "Estes são os filtros de consulta",
            description: "É possível fazer consultas com um ou vários filtros simultaneamente."
        },

        ativo: {
            title: "Filtro de ativo",
            description: "Indique se deseja obter dados ativos ou não."
        },

        botaoListar: {
            title: `Botão "Listar"`,
            description: `Por fim, clique no botão "Listar" para consultar os dados filtrados.`
        },

        cliente: {
            title: "Filtro de cliente",
            description: "Caso deseje buscar por um cliente específico, selecione-o."
        },

        cpf: {
            title: "Filtro de CPF",
            description: "Você pode filtrar os dados a partir de um CPF desejado."
        },

        cnpj: {
            title: "Filtro de CNPJ",
            description: "Filtre por dados que possuam um CNPJ em específico."
        },

        codigoInterno: {
            title: "Filtro de código interno",
            description: `Para filtrar por um código interno, especifique no campo "Código Interno".`
        },

        descricao: {
            title: "Filtro de descrição",
            description: "É possível filtrar a partir da descrição do dado desejado."
        },

        email: {
            title: "Filtro de e-mail",
            description: "Caso deseje filtrar por dados que possuem um e-mail em particular, especifique-o neste campo."
        },

        empresa: {
            title: "Filtro de empresa",
            description: "Obtenha dados a partir de uma empresa em específico."
        },

        obra: {
            title: "Filtro de obra",
            description: "Você pode consultar por uma obra específica"
        },

        nome: {
            title: "Filtro de nome",
            description: `Caso deseje filtrar por dados que possuem nomes exatos ou semelhantes à um nome em particular, especifique-o neste campo.`
        },

        nomeFantasia: {
            title: "Filtro de nome fantasia",
            description: "Obtenha dados a partir de um nome fantasia correspondente."
        },

        razaoSocial: {
            title: "Filtro de razão social",
            description: "Obtenha dados a partir de razões sociais correspondentes."
        },

        tipo: {
            title: "Filtro de tipo",
            description: "Selecione o tipo de dado a ser buscado."
        },

        usuario: {
            title: "Filtro de nome de usuário",
            description: "Obtenha dados a partir de um usuário correspondente."
        },
    },

    adicionar: {
        entrada: {
            title: `Clique em "Adicionar"`,
            // description: `Obtenha mais informações sobre como adicionar um novo dado clicando no ícone de "?" a a partir do painel seguinte.`
            description: `Você será redirecionado para a tela de cadastro.`
        },
    },

    alterar: {
        editar: {
            title: `Botão "Editar"`,
            description: (
                <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                    Após clicar em editar no dado escolhido, você será redirecionado para tela de alteração.
                </div>
            ),
        },

        desativar: {
            title: `Botão "Desativar"`,
            description: (
                <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                    Após clicar em desativar no dado escolhido, será exibido um popup pedindo a confirmação.
                    <div>
                        <strong>OBS:</strong> É possível reativar um dado a qualquer momento clicando em "Reativar" no dado que estiver inativo.
                    </div>
                </div>
            ),
        }
    }
}
 
export default AdicionarAjuda;